import moment from 'moment';
import AcademicService from "@/service/AcademicService";
import StoreGetter from "@/constants/StoreGetter";
import SweetAlertService from "@/service/SweetAlertService";
import { StaffAcademic } from "@/model/StaffAcademic";
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import employeeAcademicValidationObj from "./S070200-EmployeeAcademicValidation.js";
import Settings from '../../../constants/Settings.js';
var employeeAcademicValidation = new employeeAcademicValidationObj();
export default {
  name: "employeeAcademic",
  props: [
    "staffModel", "isAcademicViewMode"
  ],
  data: () => ({
    academicLocalization: t,
    academicDictEnum: dictEnum,
    staffAcademic: new StaffAcademic(),
    academicList: [],
    tempAcademicModel: new StaffAcademic(),
    listKey: 1,
    IsLoaded: true,
    academicObj: {
      selectAll: false
    },
  }),
  computed: {
    user() {
      return this.$store.getters[StoreGetter.user];
    },
  },
  mounted() {
    employeeAcademicValidation.academicValidation();
    this.getAllAcademics();
  },
  methods: {
    async getAllAcademics() {
      const obj = {};
      const response = await AcademicService.getAllAcademics(obj);
      if (response.data.IsSuccess) {
        this.academicList = response.data.Data;
      } else {
        SweetAlertService.warning("Warn", response.data.Message);
      }
    },
    onFileChange(payload) {
      var self = this;
      const reader = new FileReader();
      var file = payload; // in case vuetify file input
      reader.onload = (function (f) {
        return function (e) {
          var path = reader.result ? reader.result.toString() : "";
          self.staffModel.StaffAcademicList.forEach(element => {
            if (element.tempCode == self.tempAcademicModel.tempCode) {
              element.AcademicURL = path;
              element.AcademicFile = path.indexOf(",") != -1 ? path.split(",").pop() : "";
              element.DocMime = file.type;
              element.IsImageFile = path.indexOf("image") != -1 ? true : false;
            }
          });
        };
      })(file);
      if (file) {
        reader.readAsDataURL(file);
      }
    },
    OnAddEmployeeAcademicButtonClick: function () {
      var self = this;
      self.academicObj.selectAll = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          var tempCode = 1;
          var seq = 1;
          self.staffModel.StaffAcademicList.forEach(element => {
            if (element.DateFrom != null && element.DateFrom != "") {
              element.DateFrom = moment(element.DateFrom).format(Settings.DateTime.yyyymmdd);
            }
            if (element.DateTo != null && element.DateTo != "") {
              element.DateTo = moment(element.DateTo).format(Settings.DateTime.yyyymmdd);
            }
            element.IsEditMode = false;
            element.Seq = seq;
            element.tempCode = tempCode;
            tempCode++;
            seq++;
          });
          var staffAcademic = new StaffAcademic();
          staffAcademic.StaffID = self.staffModel.StaffID;
          staffAcademic.Seq = seq;
          staffAcademic.tempCode = tempCode;
          staffAcademic.IsEditMode = true;
          self.staffModel.StaffAcademicList.push(staffAcademic);
        }
      });
    },
    OnEmployeeAcademicDeleteClick: function (data) {
      var self = this;
      self.staffModel.StaffAcademicList.forEach((element, index) => {
        if (element.tempCode == data.tempCode) {
          self.staffModel.StaffAcademicList.splice(index, 1);
          return;
        }
      });
    },
    OnEmployeeAcademicSelection: function (item) {
      var self = this;
      self.tempAcademicModel = item;
      if (this.isAcademicViewMode) {
        return;
      }
      if (item.IsEditMode) {
        return;
      }
      self.IsLoaded = false;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.staffModel.StaffAcademicList.forEach(element => {
            if (element.DateFrom != null && element.DateFrom != "") {
              element.DateFrom = moment(element.DateFrom).format(Settings.DateTime.yyyymmdd);
            }
            if (element.DateTo != null && element.DateTo != "") {
              element.DateTo = moment(element.DateTo).format(Settings.DateTime.yyyymmdd);
            }
            if (element.tempCode == item.tempCode) {
              self.IsLoaded = true;
              element.IsEditMode = true;
            } else {
              self.IsLoaded = true;
              element.IsEditMode = false;
            }
          });
          self.listKey += 1;
        }
        self.IsLoaded = true;
      });
    },
    changeAcademic: function (item) {
      var self = this;
      var academicDetail = self.academicList.find(
        obj => obj.AcademicCode == item.AcademicCode
      );
      item.AcademicDes = self.user.Lang == 'EN' ? academicDetail.EDesc : academicDetail.CDesc;
    },
    OnAcademicImageOpen: function () {
      var self = this;
      $("#academicImage").click();
    },
    selectAllAcademicRecord: function () {
      var self = this;
      var IsSelected = self.academicObj.selectAll;
      self.staffModel.StaffAcademicList.forEach(function (val, index) {
        val["isSelected"] = IsSelected;
      });
    },
    closeAcademicPopup: function () {
      var self = this;
      $('#deleteAcademic').modal('hide');
    },
    deleteMultipleAcademicPopup: function () {
      var arrayList = [];
      var self = this;
      self.staffModel.StaffAcademicList.forEach(function (key, value) {
        if (key.isSelected) {
          arrayList.push(key);
        }
      });
      if (arrayList.length > 0) {
        $('#deleteAcademic').modal('show');
      }
      else {
        SweetAlertService.warning("Warn", self.academicLocalization.t(self.academicDictEnum.MSG_SelectDeleteRecord));
      }
    },
    deleteMultipleAcademic: function () {
      var self = this;
      var staffAcademicList = self.staffModel.StaffAcademicList.filter(
        obj => obj.isSelected !== true
      );
      self.staffModel.StaffAcademicList = staffAcademicList;
      self.academicObj.selectAll = false;
      $('#deleteAcademic').modal('hide');
    },
    downloadFile: function (path) {
      var win = window.open();
      win.document.write('<iframe src="' + path + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    },
    changeAcademicFormDate: function (item) {
      var self = this;
      if (new Date(item.DateFrom) > new Date(item.DateTo)) {
        SweetAlertService.warning("Warn", self.academicLocalization.t(self.academicDictEnum.MSG_DateCompare));
        item.DateFrom = moment().format(Settings.DateTime.yyyymmdd);
        return;
      }
    },
    changeAcademicToDate: function (item) {
      var self = this;
      if (new Date(item.DateFrom) > new Date(item.DateTo)) {
        SweetAlertService.warning("Warn", self.academicLocalization.t(self.academicDictEnum.MSG_DateCompare));
        item.DateTo = moment().format(Settings.DateTime.yyyymmdd);
        return;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/S070000-Employee/S070200-EmployeeProfile/S070200-EmployeeAcademic.js